/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import InfoTooltip from '../components/InfoTooltip';
import { useNavigate } from 'react-router-dom';
import { filter } from 'lodash';
import { formatDistanceToNow } from 'date-fns';
import { useEffect, useState } from 'react';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
  TextField,
} from '@mui/material';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections

import { getShellyDevices, getShellySettings, updateShellyDevices } from '../helper/backend_helper';
import { SolutionListHead } from '../components/addSolution';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'room_id', label: 'Room Id', alignRight: false },
  { id: 'deviceId', label: 'Device Id', alignRight: true },
  { id: 'BnBShortName', label: 'Type', alignRight: true },
  { id: 'actions', label: 'Category', alignRight: false },
  { id: 'actions', label: 'Position', alignRight: false },
  { id: 'checkInDate', label: 'Gen', alignRight: false },
  { id: 'checkInStatus', label: 'channel', alignRight: false },
  { id: '2', label: 'Channel Count', alignRight: false },
  { id: 'checkOutDate', label: 'Mode', alignRight: false },
  { id: '7', label: 'Image', alignRight: false },
  { id: '6', label: 'Jti', alignRight: false },
  { id: 'actions', label: 'Modified', alignRight: false },
  { id: 'actions', label: 'Ip', alignRight: false },
  { id: 'actions', label: 'SSID', alignRight: false },
  { id: 'actions', label: 'Pin Lock', alignRight: false },
  { id: 'actions', label: 'Background Color', alignRight: false },
  { id: 'actions', label: 'Cloud Options', alignRight: false },
  { id: '', label: 'Last Online', alignRight: false },
  { id: '', label: 'Online', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.category?.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ShellyDevicesPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clickedRowData, setClickedRowData] = useState(null);
  const [users, setUsers] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [updatedTime, setUpdatedTime] = useState();

  const handleSearchText = (event) => {
    setSearchText(event.target.value);
  };
  async function fetchData() {
    try {
      setLoading(true);
      const response = await getShellySettings();
      setUpdatedTime(response?.data?.data?.lastUpdatedDevices);
      const usersResponse = await getShellyDevices();
      setUsers(usersResponse?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);

  const handleOpenMenu = (event, row) => {
    setOpen(event.currentTarget);
    setClickedRowData(row);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  let filteredUsers = [];
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  filteredUsers = filteredUsers.sort((a, b) => {
    return b.name - a.name && a.room_id - b.room_id;
  });

  const handleRefresh = async () => {
    try {
      setRefreshLoading(true);
      console.log('1');
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await updateShellyDevices();
      console.log(response);
      fetchData();
      setRefreshLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setRefreshLoading(false);
    }
  };

  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));
  // Filter users based on searchText
  filteredUsers = users.filter((user) => {
    const lowerCaseSearch = searchText.toLowerCase();
    const matchesBnb = user?.name.toLowerCase().includes(lowerCaseSearch);
    const matchesGuesuName = user?.deviceId.toLowerCase().includes(lowerCaseSearch);
    return matchesBnb || matchesGuesuName;
  });

  return (
    <>
      <Helmet>
        <title> Shelly Devices </title>
      </Helmet>

      <Card sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h4">Shelly Devices{' '}<InfoTooltip width={20} title="The full inventory of Shelly smart-home hardware (relays, switches, sensors) synced from the Shelly Cloud account. Each row shows a device's name, room, device ID, type, firmware generation, channels and its live online/offline status, refreshed by the sync job. Use the search box to find a device by name or ID and press Update Now to pull the latest state and online status from Shelly." /></Typography>
            <TextField
              onChange={handleSearchText}
              value={searchText}
              size="small"
              id="outlined-search"
              label="Search"
              type="search"
            />
          </Stack>
          <Stack direction="row" spacing={2}>
            <Typography variant="h6">
              Last Update:{' '}
              {updatedTime ? formatDistanceToNow(new Date(updatedTime), { addSuffix: true }) : 'No updates'}
            </Typography>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
                width: 200,
              }}
              variant="contained"
              onClick={handleRefresh}
            >
              {refreshLoading ? <CircularProgress size={20} color="inherit" /> : 'Update Now'}
            </Button>
          </Stack>
        </Stack>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <SolutionListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    deviceId,
                    type,
                    category,
                    position,
                    gen,
                    channel,
                    channels_count,
                    mode,
                    name,
                    room_id,
                    image,
                    jti,
                    cloud_online,
                    modified,
                    ip,
                    ssid,
                    pin_lock,
                    backgroundColor,
                    cloud_options,
                    online,
                    _id,
                    lastOffline,
                  } = row;

                  return (
                    <TableRow sx={{ backgroundColor: online ? 'lightgreen' : 'lightcoral' }} key={_id}>
                      <TableCell align="center">{name}</TableCell>
                      <TableCell align="center">{room_id}</TableCell>
                      <TableCell align="center">{deviceId}</TableCell>
                      <TableCell align="center">{type}</TableCell>
                      <TableCell align="center">{category}</TableCell>
                      <TableCell align="center">{position}</TableCell>
                      <TableCell align="center">{gen}</TableCell>
                      <TableCell align="center">{channel}</TableCell>
                      <TableCell align="center">{channels_count}</TableCell>
                      <TableCell align="center">{mode}</TableCell>

                      <TableCell align="center">{image}</TableCell>

                      <TableCell align="center">{jti}</TableCell>

                      {/* <TableCell align="center">{cloud_online ? 'ONLINE' : 'OFFLINE'}</TableCell> */}
                      <TableCell align="center">{modified}</TableCell>
                      <TableCell align="center">{ip}</TableCell>
                      <TableCell align="center">{ssid}</TableCell>
                      <TableCell align="center">{pin_lock ? 'TRUE' : 'FALSE'}</TableCell>
                      <TableCell align="center">{backgroundColor}</TableCell>
                      <TableCell align="center">{cloud_options?.exclude_event_log ? 'TRUE' : 'FALSE'}</TableCell>
                      <TableCell align="center">
                        {!online ? (lastOffline ? new Date(lastOffline).toLocaleString() : '-') : '-'}
                      </TableCell>
                      <TableCell align="center">{online ? 'ONLINE' : 'OFFLINE'}</TableCell>

                      {/* <TableCell align="center">
                          <Stack
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <Button
                              onClick={() =>
                                navigate('/add_solution/update_solution', { state: { solutionData: row } })
                              }
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#B5FFD8',
                                color: '#009245',
                                '&:hover': {
                                  backgroundColor: '#B5FFD8',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<MdOutlineEdit />}
                            >
                              Edit
                            </Button>
                            <Button
                              onClick={(event) => handleDelete(event, row)}
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#FFC6C6',
                                color: '#DC2626',
                                '&:hover': {
                                  backgroundColor: '#FFC6C6',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<CiTrash />}
                            >
                              Delete
                            </Button>
                          </Stack>
                        </TableCell> */}
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
                {loading && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7}>
                      <CircularProgress size="20px" />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[100, 200, 300]}
          component="div"
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/*     
        <Link
          
          style={{ textDecoration: 'none' }}
          // to={`/dashboard/user-detail/${encodeURIComponent(JSON.stringify(clickedRow))}`}
          to={`/dashboard/user-detail?data=${encodedData}`}
        > */}
        <MenuItem
          onClick={() => navigate('/contractor/contractor-detail', { state: { clickedRowData } })}
          sx={{ color: 'success.main' }}
        >
          <Iconify icon={'eva:image-outline'} sx={{ mr: 2 }} />
          Detail
        </MenuItem>
        {/* </Link> */}
        <MenuItem>
          <Iconify icon={'eva:edit-outline'} sx={{ mr: 2 }} />
          Block
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
